<template>
  <div class="component-application-type">
    <label class="checkbox mr-5"
      v-for="(name, code) of applicationTypes" :key="code"
    >
      <input type="checkbox" v-model="selected" :value="code">
        {{ name }}
    </label>
  </div>
</template>

<script lang="ts">
import { ApplicationType, applicationTypeCode } from '@/store/applications/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ApplicationTypesInput extends Vue {
  @Prop() value!: applicationTypeCode[]

  private applicationTypes = ApplicationType

  private get selected(): applicationTypeCode[] {
    return this.value
  }

  private set selected(applicationTypeCodes: applicationTypeCode[]) {
    this.$emit('input', applicationTypeCodes)
  }
}
</script>

<style scoped>
.component-application-type {
  display:flex;
  flex-wrap: wrap;
}
input[type="checkbox"] {
  margin-right: 8px;
}

.checkbox {
  display: block;
}
</style>
